import { Collapse, InputNumber, Select } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const { Panel } = Collapse;
const { Option } = Select;

function FabricCharsCollapse({
  index,
  fc,
  genExtraFabricChar,
  setProductToUpdate,
  productToUpdate,
  setData,
  data,
  options,
  handleChangeFabricChar,
}: any) {
  const { user } = useSelector((state: any) => state.auth);
  function comparer(otherArray: any) {
    return function (current: any) {
      return (
        otherArray.filter(function (other: any) {
          return other.id == current.id;
        }).length == 0
      );
    };
  }
  return (
    <Collapse defaultActiveKey={["0"]} key={index + 2}>
      <Panel
        header={fc.name || `Fabric type num ${index + 1}`}
        key={index}
        extra={genExtraFabricChar(index)}
      >
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <th>Type of fabric</th>
              <td>
                <Select
                  disabled={
                    !user.permissions.includes("product.fabric.management") &&
                    !user.permissions.includes("product.update")
                  }
                  value={fc.name}
                  style={{ width: "100%" }}
                  placeholder="Select Type of Fabric"
                  onChange={(val: any) => {
                    setProductToUpdate({
                      ...productToUpdate,
                      fabric_chars: productToUpdate.fabric_chars.map(
                        (f_char: any) =>
                          f_char.id === fc.id ? JSON.parse(val) : f_char
                      ),
                    });
                    setData({
                      ...data,
                      fabric_chars: data.fabric_chars.map((f_char: any) =>
                        f_char.fabric_char_id === fc.id
                          ? {
                              ...f_char,
                              fabric_char_id: JSON.parse(val).id,
                            }
                          : f_char
                      ),
                    });
                  }}
                >
                  {options.fabric_chars_options &&
                    options.fabric_chars_options
                      .filter(comparer(productToUpdate.fabric_chars))
                      .map((el: any) => (
                        <Option value={JSON.stringify(el)} key={el.id}>
                          {el.name}
                        </Option>
                      ))}
                </Select>
              </td>
            </tr>
            <tr>
              <th>Weight</th>
              <td>
                <InputNumber
                  disabled={
                    !user.permissions.includes("product.fabric.management") &&
                    !user.permissions.includes("product.update")
                  }
                  style={{ width: "100%" }}
                  min={0}
                  defaultValue={fc.weight}
                  name="weight"
                  onChange={(num: number) =>
                    handleChangeFabricChar(num, "weight", fc.id)
                  }
                />
              </td>
            </tr>
            <tr>
              <th>Price</th>
              <td>
                <InputNumber
                  disabled={
                    !user.permissions.includes("product.fabric.management") &&
                    !user.permissions.includes("product.update")
                  }
                  style={{ width: "100%" }}
                  min={0}
                  defaultValue={fc.price}
                  name="price"
                  onChange={(num: number) =>
                    handleChangeFabricChar(num, "price", fc.id)
                  }
                />
              </td>
            </tr>
          </tbody>
        </table>
      </Panel>
    </Collapse>
  );
}

export default FabricCharsCollapse;
